enum Paths {
  Login = "/login",
  RecoveryEmail = "/recovery-email",
  NewPassword = "/newpassword/:passwordToken/:csrfToken",
}

export default Paths;
